/**
 * This is the uid for the public namespace that contains all publicly visible part version and document snapshot data objects.
 */
export const publicNamespaceUid = "ns_Ck0aZa3LSvbCAiRULZbxcw";
//# sourceMappingURL=staticPartVersionNamespaces.js.map